export default {"src":"/_next/static/media/goal.e9520864.svg","height":357,"width":450};